/** Textos novos da seção "Tarefas" dentro do chamado (item 3) e do print do
 * calendário pelo filtro de período global (item 8). Registrado no
 * IdiomaProvider pelo orquestrador — ver AGENTS.md. */
export const TEXTOS_SUPORTE_TAREFAS = {
  pt: {
    "Digite para filtrar colaboradores...": "Digite para filtrar colaboradores...",
    "Nenhum colaborador ativo": "Nenhum colaborador ativo",
    "Carregando tarefas...": "Carregando tarefas...",
    "Chamado vinculado": "Chamado vinculado",
    "Salve o chamado para vincular tarefas a ele.": "Salve o chamado para vincular tarefas a ele.",
    "Tarefas vinculadas a este chamado.": "Tarefas vinculadas a este chamado.",
    "Nenhuma tarefa vinculada a este chamado.": "Nenhuma tarefa vinculada a este chamado.",
    "Não foi possível carregar as tarefas do chamado.": "Não foi possível carregar as tarefas do chamado.",
    "Atualizar tarefas": "Atualizar tarefas",
    "Nova tarefa vinculada ao chamado": "Nova tarefa vinculada ao chamado",
    "Não foi possível imprimir as tarefas do período.": "Não foi possível imprimir as tarefas do período.",
  },
  en: {
    "Digite para filtrar colaboradores...": "Type to filter employees...",
    "Nenhum colaborador ativo": "No active employees",
    "Carregando tarefas...": "Loading tasks...",
    "Chamado vinculado": "Linked ticket",
    "Salve o chamado para vincular tarefas a ele.": "Save the ticket to link tasks to it.",
    "Tarefas vinculadas a este chamado.": "Tasks linked to this ticket.",
    "Nenhuma tarefa vinculada a este chamado.": "No tasks linked to this ticket.",
    "Não foi possível carregar as tarefas do chamado.": "Could not load the ticket's tasks.",
    "Atualizar tarefas": "Refresh tasks",
    "Nova tarefa vinculada ao chamado": "New task linked to the ticket",
    "Não foi possível imprimir as tarefas do período.": "Could not print the tasks for the period.",
  },
  es: {
    "Digite para filtrar colaboradores...": "Escriba para filtrar colaboradores...",
    "Nenhum colaborador ativo": "Ningún colaborador activo",
    "Carregando tarefas...": "Cargando tareas...",
    "Chamado vinculado": "Ticket vinculado",
    "Salve o chamado para vincular tarefas a ele.": "Guarde el ticket para vincular tareas a él.",
    "Tarefas vinculadas a este chamado.": "Tareas vinculadas a este ticket.",
    "Nenhuma tarefa vinculada a este chamado.": "Ninguna tarea vinculada a este ticket.",
    "Não foi possível carregar as tarefas do chamado.": "No fue posible cargar las tareas del ticket.",
    "Atualizar tarefas": "Actualizar tareas",
    "Nova tarefa vinculada ao chamado": "Nueva tarea vinculada al ticket",
    "Não foi possível imprimir as tarefas do período.": "No fue posible imprimir las tareas del período.",
  },
  "zh-CN": {
    "Digite para filtrar colaboradores...": "输入以筛选员工...",
    "Nenhum colaborador ativo": "没有在职员工",
    "Carregando tarefas...": "正在加载任务...",
    "Chamado vinculado": "关联的工单",
    "Salve o chamado para vincular tarefas a ele.": "保存工单后才能关联任务。",
    "Tarefas vinculadas a este chamado.": "与此工单关联的任务。",
    "Nenhuma tarefa vinculada a este chamado.": "没有与此工单关联的任务。",
    "Não foi possível carregar as tarefas do chamado.": "无法加载该工单的任务。",
    "Atualizar tarefas": "刷新任务",
    "Nova tarefa vinculada ao chamado": "新建关联到工单的任务",
    "Não foi possível imprimir as tarefas do período.": "无法打印该期间的任务。",
  },
} as const;
